import { GlobalStyles } from "@mui/material";
import { Outlet } from "react-router";

import EventListeningComponent from "~/features/andon/EventListeningComponent";
import { DevCheatsProvider } from "~/hooks/useDevCheats";
import { NavbarProvider } from "~/hooks/useNavbar";
import { SideNavProvider } from "~/hooks/useSideNav";

/**
 * Combines custom providers that provide context to Qubit pages.
 * @constructor
 */
export function AppProviders() {
  return (
    <>
      <GlobalStyles
        styles={{
          // this style is required because there is a red path in an svg imported from @qubit/autoparts
          ".andon-icon path": {
            fill: "currentColor !important"
          }
        }}
      />
      <NavbarProvider>
        <SideNavProvider>
          <DevCheatsProvider>
            <EventListeningComponent />
            <Outlet />
          </DevCheatsProvider>
        </SideNavProvider>
      </NavbarProvider>
    </>
  );
}
